<template>
  <div v-if="job" class="single-job-content">
    <v-card tile elevation="0" class="single-job-content-card">
      <h2 class="job-title">{{ job.title }}</h2>

      <v-list>
        <v-list-item v-for="(meta, i) in job.meta" :key="i" class="jobs-list-item-meta">
          <v-list-item-icon class="jobs-list-item-meta-icon">
            <v-icon>{{ getMetaIcon(meta) }}</v-icon>
          </v-list-item-icon>
          <span class="jobs-list-item-meta-key">{{ meta.meta_title }}:</span>
          <v-list-item-title v-text="meta.name" class="jobs-list-item-meta-title"/>
        </v-list-item>
      </v-list>

      <v-divider/>

      <h3 class="job-subtitle">Overview</h3>

      <div class="overview job-text" v-html="job.overview"/>

      <v-divider/>

      <h3 class="job-subtitle">Job Description</h3>

      <div class="description job-text" v-html="job.description"/>
    </v-card>

    <Dialog/>
  </div>
</template>

<script>
import Dialog from './Dialog';

export default {
  name: 'Content',
  components: {
    Dialog
  },
  props: {
    job: Object
  },
  methods: {
    getMetaIcon(meta) {
      if (typeof meta.taxonomy !== 'undefined') {
        switch (meta.taxonomy) {
          case 'pj_locations':
            return 'mdi-map-marker';
          case 'pj_categories':
            return 'mdi-view-grid';
          case 'pj_types':
            return 'mdi-briefcase';
          default:
            return 'mdi-record-circle';
        }
      }

      return meta.icon;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.single-job-content {

  &-card {
    padding: 5%;
  }

  .jobs-list-item-meta {
    padding-left: 0;
    min-height: 0;

    &-icon {
      margin: 0 10px 0 0 !important;

      i {
        color: #8A9FC4;
      }
    }

    &-key {
      width: 100px;
      color: #4A4A4A;
      font-family: "Avenir";
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 28px;
    }

    &-title {
      color: #4A4A4A;
      font-family: "Avenir";
      font-size: 16px;
      letter-spacing: 0;
      line-height: 28px;
    }
  }

  .job-title {
    color: #243759;
    font-family: "Zilla Slab";
    font-size: 32px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
    margin-bottom: 20px;
  }

  .job-subtitle {
    color: #243759;
    font-family: "Zilla Slab";
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0.34px;
    line-height: 29px;
    margin: 4% 0 2%;
  }

  .job-text {
    color: #4A4A4A;
    font-family: "Avenir";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 30px;
  }
}
</style>
